

<ng-container *ngIf="fg" [formGroup]="fg">

  <div class="flex gap-1">

    <div class="field flex">
      <p-inputNumber
        appNumberInput
        [formControl]="fg.controls.value"
        [placeholder]="placeholder ? (placeholder | translate) : null"
        name="value"
        [autofocus]="autofocus"
        [minFractionDigits]="2"
        [maxFractionDigits]="2"
      />
    </div>

    <div class="field">
      <!-- mozna bude potreba appendTo dat dynamic s @Input ... pokud bude nekde 'body' rozbite-->
      <p-dropdown
        [options]="CURRENCIES"
        placeholder="{{ 'shared.hour-rate.currency.placeholder' | translate }}"
        [appendTo]="appendTo"
        formControlName="currency">
      </p-dropdown>
    </div>

  </div>

</ng-container>

